import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ExpressionType_Deduction } from '@app/hcs-shared';
import { ComponentSync, LL_V_L, TS_PropRenderer } from '@nu-art/thunderstorm-frontend';
import { DefaultEditor_InputText } from '@app/styles/frontend/ui-manager/ui-components';
import { Component_TermsAndExpression } from '../../../../expression.js';
import { Component_HVValueMappingEditor } from '../../../expressions/ui/expression-builder/components/hv-value-mapping/Component_HVValueMappingEditor.js';
import { exists } from '@nu-art/ts-common';
import { ModuleFE_Expression } from '../../../../_entity.js';
import './Editor_DynamicExpression.scss';
import { FadeScrollWrapper } from '@app/styles';
export class Editor_DynamicExpression extends ComponentSync {
    static Config_NoEditing = {
        label: false,
        terms: false,
        outputType: false,
        output: false,
    };
    //######################### Life Cycle #########################
    deriveStateFromProps(props, state) {
        state.config = props.config;
        state.editMode = props.editMode;
        state.editable = props.editable;
        state.editable.setOnChanged(async () => this.forceUpdate());
        return state;
    }
    //######################### Logic #########################
    collectExpressionVarIds = (expression, varIds = new Set()) => {
        if (expression.associatedVar)
            varIds.add(expression.associatedVar);
        expression.terms.forEach(term => {
            term.atoms.forEach(atom => {
                if (atom.leftHand?.type === 'variable') {
                    if (atom.leftHand.id)
                        varIds.add(atom.leftHand.id);
                }
                else if (atom.leftHand?.type === 'expression') {
                    const innerExpression = ModuleFE_Expression.cache.unique(atom.leftHand.id);
                    if (exists(innerExpression))
                        this.collectExpressionVarIds(innerExpression, varIds);
                }
            });
        });
        return varIds;
    };
    //######################### Render #########################
    render() {
        return _jsxs(FadeScrollWrapper, { className: 'e__expression-dynamic', children: [this.render_Label(), this.render_Terms(), this.render_Output()] });
    }
    render_Label = () => {
        return _jsx(TS_PropRenderer.Vertical, { label: 'Label', children: _jsx(DefaultEditor_InputText, { disabled: !this.state.editMode || !this.state.config.label, editable: this.state.editable, prop: 'label' }) });
    };
    render_Terms = () => {
        return _jsx(TS_PropRenderer.Vertical, { label: 'Terms', className: 'e__expression-dynamic__terms', children: _jsx(LL_V_L, { children: _jsx(Component_TermsAndExpression, { editable: this.state.editable, viewMode: !this.state.editMode, hideDnD: true }) }) });
    };
    render_Output = () => {
        if (this.state.editable.get('expressionType') !== ExpressionType_Deduction.dbKey)
            return;
        const editableValueMapping = this.state.editable.editProp('valueMapping', { '': [] });
        const mode = this.state.editMode ? 'edit' : 'view';
        const userVarIds = Array.from(this.collectExpressionVarIds(this.state.editable.item));
        return _jsx(TS_PropRenderer.Vertical, { label: 'Output', children: _jsx(Component_HVValueMappingEditor, { mode: mode, editable: editableValueMapping, usedVarIds: userVarIds }) });
    };
}
//# sourceMappingURL=Editor_DynamicExpression.js.map